var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "pagination-app" } },
    [
      _vm.providerResultsShowing < _vm.providers.length
        ? _c("div", [
            _c("p", { staticClass: "p-large" }, [
              _vm._v("\n      Showing "),
              _c("strong", [_vm._v(_vm._s(_vm.providerResultsShowing))]),
              _vm._v(" out of\n      "),
              _c("strong", [_vm._v(_vm._s(_vm.providers.length))]),
              _vm._v(" therapists\n    "),
            ]),
          ])
        : _c("div", [
            _c("p", { staticClass: "p-large" }, [
              _vm._v("\n      Showing "),
              _c("strong", [_vm._v(_vm._s(_vm.providers.length))]),
              _vm._v(" out of\n      "),
              _c("strong", [_vm._v(_vm._s(_vm.providers.length))]),
              _vm._v(" therapists\n    "),
            ]),
          ]),
      _vm._v(" "),
      _vm._l(_vm.providerLoaded, function (provider, index) {
        return _c(
          "div",
          { key: index },
          [
            _c("ResultCard", {
              attrs: {
                isTab2: false,
                culturalExperience: provider.CulturalExpertise,
                firstName: provider.FirstName,
                gender: provider.Gender,
                languages: provider.Languages,
                regions: provider.Regions,
                surname: provider.LastName,
                therapistExperience: provider.TherapistExpertise,
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.providerResultsShowing < _vm.providers.length
        ? _c("div", [
            _c("p", { staticClass: "p-large" }, [
              _vm._v("\n      Showing "),
              _c("strong", [_vm._v(_vm._s(_vm.providerResultsShowing))]),
              _vm._v(" out of\n      "),
              _c("strong", [_vm._v(_vm._s(_vm.providers.length))]),
              _vm._v(" therapists\n    "),
            ]),
          ])
        : _c("div", [
            _c("p", { staticClass: "p-large" }, [
              _vm._v("\n      Showing "),
              _c("strong", [_vm._v(_vm._s(_vm.providers.length))]),
              _vm._v(" out of\n      "),
              _c("strong", [_vm._v(_vm._s(_vm.providers.length))]),
              _vm._v(" therapists\n    "),
            ]),
          ]),
      _vm._v(" "),
      _vm.providerResultsShowing < _vm.providers.length ||
      _vm.providers.length > _vm.providerResultsShowing
        ? _c("div", { staticClass: "button__wrapper-center" }, [
            _c(
              "button",
              {
                staticClass: "button button-tertiary",
                attrs: { "aria-label": "Load more results" },
                on: {
                  click: function ($event) {
                    _vm.providerResultsShowing += 20
                  },
                },
              },
              [_vm._v("\n      See more\n    ")]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }